  <template>
    <div class="mine-module">
        <div class="repair-order">
            <div class="search">
                <van-search v-model="name" placeholder="搜索姓名/手机/会员卡号" use-action-slot @search="onSearch">
                </van-search>
            </div>
            <van-tabs animated :active="tabNum" @click="changeTab">
                <van-tab :title="`处理中(${listData.length})`">
                    <div v-for="item,index in listData" :key="index" class="order-list flex-col flex-y-center" @click="toDetail(item.guid,item.storeNo,item.workNoTypeId,item.sourceType)">
                        <div class="order-item">
                            <div class="flex-y-center">
                                <div class="date flex-1">{{item.createTime }}</div>
                                <div :class="`type flex-x-center flex-y-center ${ item.workNoType == '建议'?'orange':''} ${ item.workNoType == '投诉'?'red':''}`">
                                    {{item.workNoType}}</div>
                            </div>
                            <div class="user">顾客：{{item.customerName}} {{item.customerMobile}}</div>
                        </div>
                    </div>
                    <div v-if="showEmpty">
                        <van-empty image="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无" />
                    </div>
                </van-tab>

                <van-tab :title="`已解决(${endListData.length})`">
                    <div v-for="item,index in endListData" :key="index" class="order-list flex-col flex-y-center" @click="toDetail(item.guid,item.storeNo,item.workNoTypeId,item.sourceType)">
                        <div class="order-item">
                            <div class="flex-y-center">
                                <div class="date flex-1">{{item.createTime }}</div>
                                <div class="type flex-x-center flex-y-center gray">
                                    {{item.workNoType}}</div>
                            </div>
                            <div class="user">顾客：{{item.customerName}} {{item.customerMobile}}</div>
                        </div>
                    </div>
                    <div v-if="showEndEmpty">
                        <van-empty image="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无" />
                    </div>
                </van-tab>

            </van-tabs>
        </div>

    </div>
</template>

  <script>
import request from "@/utils/request";
import { Toast } from 'vant'

export default {
    name: "repairOrderList",
    data() {
        return {
            workNoType: 1, //分类:3 投诉 1 反馈/建议
            tabNum: 0, // tab下标
            showEmpty: false, //列表空状态
            showEndEmpty: false, //列表空状态
            active: "1",
            listData: [], // 处理中列表
            endListData: [], // 已解决列表
            name: "", //筛选
            workNoStatus: "",
        };
    },
    mounted() {
        this.workNoType = this.$route.query.type

        if (this.workNoType == 1) {
            document.title = '反馈工单'
        } else {
            document.title = '投诉工单'
        }
        this.getInHandList();
    },
    methods: {
        // 切换tab类别
        changeTab(e) {
            if (e == 0) {
                this.getInHandList();
            } else {
                this.getEndList();
            }
            this.name = ''
            this.showEmpty = false
            this.showEndEmpty = false

        },
        // 处理中列表
        getInHandList() {
            return request({
                url: `/work/workNoList?name=` + this.name + "&workNoStatus=" + 1 + "&workNoType=" + this.workNoType,
                method: "get",
            }).then((res) => {
                if (res.data.workOrderDTOS.length == 0) {
                    this.showEmpty = true
                    this.listData = []
                } else {
                    this.listData = res.data.workOrderDTOS
                }
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 已解决列表
        getEndList() {
            return request({
                url: `/work/workNoList?name=` + this.name + "&workNoStatus=" + 3 + "&workNoType=" + this.workNoType,
                method: "get",
            }).then((res) => {
                if (res.data.workOrderDTOS.length == 0) {
                    this.showEndEmpty = true
                    this.endListData = []
                } else {
                    this.endListData = res.data.workOrderDTOS
                }
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 筛选
        onSearch(event) {
            this.name = event
            if (this.tabNum == 0) {
                this.getInHandList();
            } else {
                this.getEndList();
            }
        },
        // 跳转详情
        toDetail(guid, store, type, source) {
            this.$router.push({ name: "repairOrderDetail", query: { type: type, guid: guid, store: store, source: source } });
        },
    },
};
</script>

<style scoped lang="less">
.repair-order .van-tabs__line {
    display: none;
}
.mine-module {
    height: 100%;
    overflow-y: auto;
}
:deep(.repair-order .van-tab) {
    flex: 0 0 33% !important;
    padding: 0 !important;
    height: 70px !important;
    line-height: 70px !important;
    color: #a0acb5;
}

:deep(.repair-order .van-tab--active .van-tab__text--ellipsis) {
    height: 70px !important;
    line-height: 70px;
    background: #2fd0d5 !important;
    border-radius: 35px !important;
    color: #fff !important;
    padding: 0 20px;
}
:deep(.van-tabs__line) {
    background-color: transparent;
}
:deep(.repair-order .van-tabs__nav) {
    position: relative;
    display: flex;
    -webkit-user-select: none;
    user-select: none;
    padding: 0 30px;
    justify-content: space-around;
}

.repair-order .search {
    margin: 20px 0 30px;
}

.repair-order .order-item {
    width: 690px;
    height: 258px;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    font-size: 28px;
    color: #35434c;
    padding: 30px 30px 40px;
    margin-bottom: 20px;
}

.order-item .date {
    color: #a0acb5;
    text-align: left;
}

.order-item .user {
    margin: 34px 0 28px;
}

.order-item .type {
    font-size: 26px;
    color: #ffffff;
    width: 104px;
    height: 46px;
    border-radius: 23px;
    line-height: 26px;
    background-color: #26a4f4;
}
.order-list {
    padding-top: 25px;
}
.orange {
    background-color: #ffa527 !important;
}
.gray {
    background-color: #a0acb5 !important;
}
.red {
    background-color: #ff7777 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>



